<template>
  <p
    v-bind="$attrs"
    :class="twMerge('text-xs text-neutral-400', $attrs.class as string)"
  >
    <slot />
  </p>
</template>

<script setup lang="ts">
import { twMerge } from 'tailwind-merge'
</script>
